/**
 * Shared design tokens for the sso2 sign-in screens.
 *
 * Kept as plain constants (not only in the MUI theme) so the bespoke
 * frosted-glass / topographic styling stays consistent across AuthPage,
 * OtpPage and MagicLinkLandingPage without threading the theme everywhere.
 *
 * Fonts are deliberately system stacks — the sign-in page must never depend
 * on an external font host (a failed/slow webfont fetch must not affect the
 * most important page in the platform).
 */
export var brand = {
    // Surfaces
    bg: '#0a0e14',
    card: 'rgba(19, 26, 36, 0.82)',
    cardBorder: 'rgba(255, 255, 255, 0.07)',
    cardShadow: '0 24px 70px -24px rgba(0, 0, 0, 0.75)',
    // Text
    textPrimary: '#e8eef3',
    textSecondary: '#90a0ad',
    textMuted: '#5f6f7b',
    // Primary (ArcGIS "Sign In") button
    primary: '#5d8197',
    primaryHover: '#6e93a9',
    onPrimary: '#0a141b',
    // Secondary (outlined) buttons + inputs
    field: '#0f1620',
    fieldHover: '#15202c',
    fieldBorder: '#27333f',
    fieldBorderHover: '#3a4a58',
    divider: 'rgba(255, 255, 255, 0.09)',
    // Fonts (system only — no network dependency)
    sans: '-apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, Helvetica, Arial, sans-serif',
    mono: 'ui-monospace, "SFMono-Regular", Menlo, Consolas, "Liberation Mono", monospace',
};
